module.exports = __webpack_public_path__ + "img/14_003.52194de5.webp";